<template>
  <div class="com-intr-block">
    <div class="com-intr-content">
      <div class="com-intr-title">
        <title-text title="公司概况"></title-text>
      </div>
      <p>
        跑团邦成立于2015年，专注于移动互联网体育<br>
        致力于成为中国互联网体育行业有影响力的企业之一<br>
        也是中国服务用户最多的<br>
        互联网体育综合服务运营商企业之一
      </p>
      <img src="../../../assets/images/com-p1.png">
    </div>
  </div>
</template>

<script>
import TitleText from './TitleText'

export default {
  name: 'ComIntr',
  components: {TitleText}
}
</script>

<style scoped lang="stylus">
  .com-intr-block
    background-image url("../../../assets/images/com-intr-first-bg.png")
    background-position center
    background-size cover
    margin-top 60px
    height 359px
    .com-intr-content
      width 1070px
      position relative
      margin 0 auto
      .com-intr-title
        width 11%
        padding-top 4px
      p
        width 54%
        font-size 24px
        line-height 43px
        display inline-block
        margin 0
      img
        position absolute
        right -109px
        height 387px
        top 40px
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/components/ComIntr.vue